import { RG_TYPE as t } from "@project-rouge/rg-core";
import { getArea as o } from "../index3.js";
import { getRgObjectsAtLevel as c } from "../../../utils/rg-util/index3.js";
import { isServiceTechSpace as i } from "../../queries/index7.js";
const g = (e, r) => o(c(e, t.TechnicalSpace, r).filter(i));
export {
  g as getLevelServicesArea
};
//# sourceMappingURL=index30.js.map
